import React, { useState } from 'react';
import { View, Text, TouchableOpacity, TextInput, ScrollView } from 'react-native';
import { Task } from '../types';
import { styles } from '../styles';

interface TasksViewProps {
  tasks: Task[];
  onToggleTask: (taskId: number) => void;
  onAddTask: (title: string) => void;
}

export function TasksView({ tasks, onToggleTask, onAddTask }: TasksViewProps) {
  const [newTaskTitle, setNewTaskTitle] = useState('');

  const handleAddTask = () => {
    if (newTaskTitle.trim()) {
      onAddTask(newTaskTitle.trim());
      setNewTaskTitle('');
    }
  };

  const incompleteTasks = tasks.filter(t => !t.completed);
  const completedTasks = tasks.filter(t => t.completed);

  return (
    <View style={styles.contentContainer}>
      <Text style={styles.contentTitle}>Aufgaben</Text>
      
      <View style={styles.taskInputContainer}>
        <TextInput
          style={styles.taskInput}
          value={newTaskTitle}
          onChangeText={setNewTaskTitle}
          placeholder="Neue Aufgabe..."
          onSubmitEditing={handleAddTask}
        />
        <TouchableOpacity style={styles.taskAddButton} onPress={handleAddTask}>
          <Text style={styles.taskAddButtonText}>+</Text>
        </TouchableOpacity>
      </View>

      <ScrollView style={styles.taskList}>
        {incompleteTasks.map(task => (
          <TouchableOpacity 
            key={task.id} 
            style={styles.taskItem}
            onPress={() => onToggleTask(task.id)}
          >
            <View style={styles.taskCheckbox} />
            <Text style={styles.taskTitle}>{task.title}</Text>
          </TouchableOpacity>
        ))}
        
        {completedTasks.length > 0 && (
          <>
            <Text style={styles.taskSectionTitle}>Erledigt</Text>
            {completedTasks.map(task => (
              <TouchableOpacity 
                key={task.id} 
                style={[styles.taskItem, styles.taskItemCompleted]}
                onPress={() => onToggleTask(task.id)}
              >
                <View style={[styles.taskCheckbox, styles.taskCheckboxChecked]} />
                <Text style={[styles.taskTitle, styles.taskTitleCompleted]}>{task.title}</Text>
              </TouchableOpacity>
            ))}
          </>
        )}
        
        {tasks.length === 0 && (
          <Text style={styles.emptyText}>Keine Aufgaben vorhanden</Text>
        )}
      </ScrollView>
    </View>
  );
}
